<script setup>
import ProgressDots from '../../atoms/progress/ProgressDots';
import {
    useModalStore,
} from '../../../stores/modal-store';

const modal = useModalStore();
</script>

<template>
    <div
        v-if="modal.active"
        class="c-progressPopup"
        data-qa="loading dots"
    >
        <ProgressDots/>
    </div>
</template>

<style lang="scss">
@import '../../../assets/scss/settings/z-index';

.c-progressPopup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: $z-index-progress-popup;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--k-white-alpha-90);
}
</style>
